export default __webpack_public_path__ + "static/media/img-0276-malta-full-face.e58af7eb.png";